import { useRequest } from 'ahooks'
import * as React from 'react'
import { useState, useEffect } from 'react'
import {
  getAccessToken,
  local_storage_keys,
  setUserLevel,
} from '../shared-constants/localstorage'
import { userLevel } from '../shared-constants/userLevel'
import { decodeToken } from '../shared-api/api'
import { pathes } from '@/routing/pathes'


interface IUserInfo{
  DisplayName:string,
  Mobile:string,
  sub:string
}

export const UserInfoContext = React.createContext({
  userInfo: {} as IUserInfo,
  setUserInfo: (key: any) => {},
  fetchDecodeToken:()=>{}
});

const UserInfoContextProvider = (props: any) => {
  const locale_data = JSON.parse(
    localStorage.getItem(local_storage_keys.USER_INFO_CONTEXT) ?? '{}',
  )
  const [userInfo, setUserInfo] = useState<IUserInfo>(
    locale_data.userInfo ?? '',
  )

 const { runAsync: fetchDecodeToken, loading: decodeTokenLoading } = useRequest(
    decodeToken,
    {
      manual: true,
      debounceWait: 1000,
      debounceLeading: true,
      onSuccess(data: any) {
        setUserInfo(data)
        if (
          data[
            'http://schemas.microsoft.com/ws/2008/06/identity/claims/role'
          ].includes('level2')
        ) {
          setUserLevel(userLevel.LEVEL2)
        } else {
          setUserLevel(userLevel.LEVEL1)
        }
      },
      onError(error: any) {},
    },
  )

  const userInfoContext = {
    userInfo: userInfo,
    setUserInfo: setUserInfo,
    fetchDecodeToken
  };


  useEffect(() => {
    if (!window.location.href.includes(pathes.CINEMA)) {
      if (getAccessToken()) fetchDecodeToken()
    }
  }, [])

  useEffect(() => {
    const data_storage={
        userInfo,
        fetchDecodeToken
    }
    localStorage.setItem(
      local_storage_keys.USER_INFO_CONTEXT,
      JSON.stringify(data_storage),
    )
  }, [userInfo])

  return (
    <UserInfoContext.Provider value={userInfoContext}>
      {props.children}
    </UserInfoContext.Provider>
  )
}

export default UserInfoContextProvider
